import { Badge, BadgeProps } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";

type BadgeColor = NonNullable<BadgeProps["color"]>;

const STATUS_BADGE = new Map<GraphQL.TaxReviewStatus, { label: string; color: BadgeColor }>([
  [GraphQL.TaxReviewStatus.Submitted, { label: "Pending Review", color: "orange" }],
  [GraphQL.TaxReviewStatus.Approved, { label: "Approved", color: "green" }],
  [GraphQL.TaxReviewStatus.Denied, { label: "Denied", color: "red" }],
]);

const useStyles = createStyles({ badge: { display: "contents" } });

interface TaxReviewStatusBadgeProps {
  status: GraphQL.TaxReviewStatus;
}

export const TaxReviewStatusBadge: React.FC<TaxReviewStatusBadgeProps> = ({ status }) => {
  const { classes } = useStyles();
  // The backend can deploy new review statuses ahead of this frontend; an unmapped status renders nothing
  // rather than crashing the settings page.
  const badge = STATUS_BADGE.get(status);
  if (!badge) return null;
  const { label, color } = badge;
  return (
    <span className={classes.badge} data-testid="tax-review-status-badge">
      <Badge variant="round" size="small" color={color} label={label} />
    </span>
  );
};
